import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/contracts',
    name: 'Contract',
    component: {
      name: 'AdminContracts',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'contract',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminContractsIndex',
        component: () => import('../views/ContractsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminContractNew',
        component: () => import('../views/ContractInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminContractsIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminContractShow',
        component: () => import('../views/ContractShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminContractsIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminContractDetails',
            component: () => import('../views/ContractDetails.vue'),
            meta: {
              backRoute: { name: 'AdminContractsIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminContractEdit',
            component: () => import('../views/ContractInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminContractDetails' },
            },
          },
          {
            path: 'contract_timesheets',
            name: 'ContractTimesheet',
            component: {
              name: 'AdminContractTimesheet',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminAccountIndex' },
              resource: 'contract_timesheet',
            },
            children: [
              {
                path: '',
                name: 'AdminContractTimesheetsIndex',
                component: () => import('../views/contractTimesheet/ContractTimesheetsIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminContractsIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminContractTimesheetNew',
                component: () => import('../views/contractTimesheet/ContractTimesheetInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminContractTimesheetsIndex' },
                },
              },
              {
                path: ':contractTimesheetId(\\d+)',
                name: 'AdminContractTimesheetShow',
                component: () => import('../views/contractTimesheet/ContractTimesheetShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminContractTimesheetsIndex',
                  },
                  tArgs: route => ({ name: route.params?.contractTimesheetId }),
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminContractTimesheetDetails',
                    component: () => import('../views/contractTimesheet/ContractTimesheetDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminContractTimesheetsIndex' },
                    },
                  },
                  {
                    path: 'edit',
                    name: 'AdminContractTimesheetEdit',
                    component: () => import('../views/contractTimesheet/ContractTimesheetInput.vue'),
                    meta: {
                      action: 'edit',
                      backRoute: { name: 'AdminContractTimesheetsIndex' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));